import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';

@inject(Backend, Router)
export class BatchDetailsScreen {
    backend;
    router;

    batch;

    showDeleteConfirm = false;
    deleteError;

    constructor(backend, router) {
        this.backend = backend;
        this.router = router;
    }

    activate(params) {
        return this.backend.BatchCrud_details(params.batchId)
                    .then(batch => this.batch = batch);
    }
}
